<script lang="ts">
	import { onMount } from "svelte";
	import { makeComponentClassList } from "../utils";

	export let value = "";
	export let placeholder = "";
	export let defaultClassName = "";
	export let disabled = false;
	export let error = false;
	export let length: number = Infinity;
	export let tel = false;
	export let id = "";
	export let backgroundColor = "";
	export let clearButtonDisplay = true;
	export let clearButtonForceDisplay = false;
	export let noFocusoutline = false;
	export let action = (node: HTMLElement) => {};

	export let clearCallback: () => void = () => {
		value = "";
	};

	export let password = false;

	$: clearDisplay =
		(value.length > 0 && clearButtonDisplay) || clearButtonForceDisplay;
	$: classVariables = makeComponentClassList($$props);

	let input: HTMLInputElement;
	let focus = false;

	onMount(() => {
		const outerFocus = () => {
			focus = true;
		};
		const outerBLUR = () => {
			focus = false;
		};

		input.addEventListener("focus", outerFocus);
		input.addEventListener("blur", outerBLUR);
	});

</script>

<div
	use:action
	class:focus
	class:disabled
	class:error
	class:noFocusoutline
	class:hasSlot={clearButtonDisplay}
	class={defaultClassName + classVariables}
	style={`background-color: ${backgroundColor};`}
	on:click={() => input.focus()}>
	<slot name="left-icon" />
	{#if password}
		<input
			id={id}
			name={id}
			type="password"
			disabled={disabled}
			placeholder={placeholder}
			maxlength={length}
			class:error
			bind:value
			bind:this={input}
			on:input
			on:focus
			on:blur
			on:keydown />
	{:else if tel}
		<input
			id={id}
			name={id}
			type="tel"
			disabled={disabled}
			placeholder={placeholder}
			maxlength={length}
			class:error
			bind:value
			bind:this={input}
			on:input
			on:focus
			on:blur
			on:keydown />
	{:else}
		<input
			id={id}
			name={id}
			type="text"
			disabled={disabled}
			placeholder={placeholder}
			maxlength={length}
			class:error
			bind:value
			bind:this={input}
			on:input
			on:focus
			on:blur
			on:keydown />
	{/if}
	{#if clearDisplay}
		{#if $$slots.clear}
			<slot name="clear" />
		{:else}
			<i on:click={() => clearCallback()}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="15"
					height="15"
					viewBox="0 0 15 15">
					<line x1="0" y1="0" x2="15" y2="15" stroke-width="1" />
					<line x1="0" y1="15" x2="15" y2="0" stroke-width="1" />
				</svg>
			</i>
		{/if}
	{/if}
</div>

<style lang="scss">
	@import "../variables.scss";

	i {
		display: flex;
		align-items: center;
	}

	div {
		display: flex;
		width: 100%;
		height: 100%;
		border-radius: 5px;
		border: none;
		padding: 6px 10px;
		box-sizing: border-box;
		transition: box-shadow 0.1s;
		background-color: white;
		cursor: text;
		color: inherit;
		font-size: inherit;
		font-weight: inherit;

		&.focus {
			outline: none;
			box-shadow: 0 0 0 2pt var(--signature-blue);
		}

		&.disabled {
			background-color: var(--default-disabled-btn-1);
		}

		&.error {
			outline: none;
			box-shadow: 0 0 0 2pt var(--error-color-1);
		}
		&.noFocusoutline {
			box-shadow: none !important;
		}
		&.hasSlot {
			display: flex;
			align-items: center;
			svg {
				line {
					stroke: #bcbfc3;
					transition: stroke 0.15s;
				}
			}

			i:hover {
				cursor: pointer;

				line {
					stroke: #686a6d;
				}
			}

			input {
				flex-grow: 1;
			}
		}
	}

	input {
		width: 100%;
		background: none;
		border: none;
		outline: none;

		color: inherit;
		font-size: inherit;
		font-weight: inherit;
		&::placeholder {
			color: var(--default-disabled-btn-1);
			font-weight: 200;
		}

		&:disabled {
			&::placeholder {
				color: inherit;
			}
		}

		&.error {
			color: inherit;
		}
	}

</style>
